// Menu is controlled by UI component, so check the DOM for that
import Behaviour from '@/core/Behaviour'
import Headroom from 'headroom.js'

export default class Header extends Behaviour {
	mount = () => {
		// construct an instance of Headroom, passing the element
		this.headroom = new Headroom(this.$el, {
			// vertical offset in px before element is first unpinned
			offset: 5,
			// scroll tolerance in px before state changes
			tolerance: 5
		})
		// initialise
		this.headroom.init()

		this.$$eventBus.on('draw/open:before', () => {
			document.body.classList.add('has-open-menu')
		})

		this.$$eventBus.on('draw/close:before', () => {
			document.body.classList.remove('has-open-menu')

		})
	}

	unmount = () => {
		this.headroom.destroy()
	}
}


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
